import moment from "moment";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { DATE_FORMAT } from "../app/contants";

function TPLastTreatmentStmt(props) {
	const { formData, onChange } = props;
	const [data, setData] = useState({
		startDate: null,
		endDate: null
	});

	const {
		F242: completionDate
	} = useSelector(state => state.form.formData);

	useEffect(() => {
		let startDate = moment(completionDate).format(DATE_FORMAT);

		setData({
			startDate,
			endDate: calculateEndDate(startDate)
		})
	}, [completionDate]);

	useEffect(() => {
		let timer = setTimeout(() => {
			onChange(data);
		})
		
		return (() => {
			clearTimeout(timer);
		});
	}, [data]);

	function calculateEndDate(date) {
		return moment(date).add(180, 'days').format(DATE_FORMAT);
	}

	return (
		<React.Fragment>
			<div className="form-inline">
				<p className="mb-0 treatment-plan-statement">The last Treatment Plan update was completed on
          <span className="form-control prn-readonly-text ml-1">{data.startDate}</span>.
          The next treatment is due to be completed on
          <span className="form-control prn-readonly-text ml-1">{data.endDate}</span>
				</p>
			</div>
			<hr className="mt-4 mb-4" />
		</React.Fragment>
	)
}

export default TPLastTreatmentStmt;